<template>
    <div class="col meldingen">
        <div class="row no-padding">
            <div class="col-md-12 margin-bottom-20" v-html="site.intro"></div>

            <div class="col-md-6 melding" v-for="(block, key) in site.blocks" :key="key">
                <component-block :block="block"></component-block>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentBlock from "@/components/ComponentBlock.vue";

export default {
    components: {
        ComponentBlock,
    },
    computed: {
        site() {
            return this.$store.getters.getSiteData;
        }
    },
}
</script>